import React from 'react'
import TableActualite from '../../Components/table/TableActualite'

const Actualite = () => {
  return <TableActualite />
}

export default Actualite
